import { useEffect, useState } from 'react';
import { decodeToken } from 'react-jwt';
import { Navigate } from 'react-router-dom';
 
const PrivateRoutes = ({ children }: { children: JSX.Element; }) => {
    // const authenticationToken = sessionStorage.getItem('accessToken');

    const authUser: any | null = localStorage.getItem("authUser") 
	? JSON.parse(localStorage.getItem("authUser") as string) 
	: null;


    if (authUser == "null" ) {
        return <Navigate to="/" />;
    }

    if (!authUser?.value?.AUTHTOKEN ) {
        return <Navigate to="/" />;
    }
    // const userData: any = decodeToken(authenticationToken);
    // if (!userData?.UserId) {
    //     return <Navigate to="/" />;
    // }
 
    // if (userData?.exp < Date.now() / 1000) {
    //     return <Navigate to="/401" />;
    // }
    // const userHasRequiredRole = roles.includes(userData?.RoleName);
    // if (!userHasRequiredRole) {
    //  return <Navigate to="/403" />;
    // }
 
    return children;
};
 
export default PrivateRoutes;